<template>
	<div class="grade-percent">
	    <canvas :id="'canvas'+id"></canvas>
	    <span :id="'score'+id">{{score}}</span>
	</div>
</template>
<script>
	export default{
		name:'canvasScore',
		props:{
			score:{
				type:Number,
				default:30
			},
			id:{
				type:Number,
				default:1
			}
		},

		methods:{
			initCanvas(){
				var num =this.score;
		        var w = document.getElementsByClassName('grade-percent')
		        var c = document.getElementById("canvas"+this.id);
        		var score = document.getElementById("score"+this.id);

		        score.style.marginTop ='-'+ parseInt(score.offsetHeight/2)+'px'
		        score.style.marginLeft ='-' +  parseInt(score.offsetWidth/2)+'px'
//		        score.style.font-size ='-' +  parseInt(score.offsetFont-size/2)+'px'
		        var ctx = c.getContext('2d');
		        var width = w[0].offsetWidth;
		        var height = w[0].offsetHeight;
		        if (window.devicePixelRatio) {
		            c.style.width = "40px";
		            c.style.height ="40px";
		            c.height = height * window.devicePixelRatio;
		            c.width = width * window.devicePixelRatio;
		            ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
		        }
		        var centerX = w[0].offsetWidth/2;   //Canvas中心点x轴坐标
		        var centerY = w[0].offsetHeight/2;  //Canvas中心点y轴坐标
		        var rad = Math.PI*2/100; //将360度分成100份，那么每一份就是rad度

		        drawCircle(ctx,1-(num/5*100));
		        function drawCircle(ctx,percent){
		            //画白色的静态圆
		            ctx.save();
		            ctx.strokeStyle = "#28c667";
		            ctx.shadowColor="#fff";
		            ctx.lineWidth = 3;
		            ctx.beginPath();
		            ctx.arc(centerX, centerY, centerX-3, 0, Math.PI*2, true);
		            ctx.stroke();
		            ctx.closePath();
		            ctx.restore();

		            //画进度环
		            ctx.save();
		            ctx.strokeStyle = "#ccc";
		            ctx.shadowColor="#fff";
		            ctx.lineWidth = 3;
		            ctx.beginPath();
		            ctx.arc(centerX, centerY, centerX-3, -Math.PI/2, -Math.PI/2 +percent*rad, false);
		            ctx.stroke();
		            ctx.closePath();
		            ctx.restore();

		        }
			},
		},
		mounted(){
			this.initCanvas();
		}

	}
</script>



// WEBPACK FOOTER //
// src/common/cmpnt/CanvasScore/CanvasScore.vue